<button mat-icon-button class="close" tabindex="-1" mat-dialog-close>x</button>
<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">Document Preview</h2>

<mat-spinner color="primary" diameter="20" *ngIf="!thumbnailLoaded"></mat-spinner>

<mat-dialog-content class="mat-typography">    
  <img [src]="'data:image/png;base64,' + thumbnailData" alt="Preview Document"  *ngIf="thumbnailLoaded" />
</mat-dialog-content>